import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { LeftNavClosedIcon, LeftNavOpenedIcon } from "@icons";

interface Props {
    isShown: boolean;
    isDisabled: boolean;
    onToggle: () => void;
}

const iconClassName = "icon-color-gray-900 icon-rotate-180";

export const CoaMappingPreviewSourcesToggle = ({
    isShown,
    isDisabled,
    onToggle,
}: Props) => {
    const label = isShown ? "Hide mapped sources" : "Show mapped sources";
    return (
        <Tooltip content={label}>
            <Button
                variant="secondary"
                size="md"
                iconOnly
                onClick={onToggle}
                disabled={isDisabled}
                aria-label={label}
                aria-expanded={isShown}
            >
                {isShown ? (
                    <LeftNavClosedIcon className={iconClassName} />
                ) : (
                    <LeftNavOpenedIcon className={iconClassName} />
                )}
            </Button>
        </Tooltip>
    );
};
